import React from "react";
import { StyleSheet, Text, View } from "react-native";

import { type EventFilterOption } from "@/schemas/events/filter/EventFilterOption";
import { themes } from "@/Components/Styling/themeConfigs";
import { type EventOverview } from "@/schemas/events/EventOverview";
import WebCard from "@/Components/Cards/WebCard";

type Props = {
  section: EventFilterOption;
  events: EventOverview[];
};

export function EventSummary({ section, events }: Props): React.JSX.Element {
  const currentTheme = themes.morning;

  const getEventCount = (id: string): number => {
    return events.filter(
      (event) =>
        event.type === id ||
        event.status === id ||
        event.location.address.countryCode === id,
    ).length;
  };

  const styles = StyleSheet.create({
    title: {
      fontSize: currentTheme.typography.h2.size.web,
      color: currentTheme.typography.h2.color,
      marginBottom: 12,
    },

    row: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: 8,
    },

    categoryMeta: {
      flexDirection: "row",
      alignItems: "center",
      gap: 8,
    },

    categoryName: {
      fontSize: currentTheme.typography.h3.size.web,
      color: currentTheme.typography.h3.color,
    },

    countContainer: {
      minWidth: 24,
      alignItems: "flex-end",
    },

    categoryCount: {
      fontSize: currentTheme.typography.h3.size.web,
      color: currentTheme.typography.h3.color,
    },
  });

  return (
    <WebCard>
      <Text style={styles.title}>{section.label}</Text>
      {Object.entries(section.attribute.map).map(([key, value]) => (
        <View key={key} style={styles.row}>
          <View style={styles.categoryMeta}>
            <Text style={styles.categoryName}>{value.iconLabel}</Text>
            <Text style={styles.categoryName}>{value.label}</Text>
          </View>
          <View style={styles.countContainer}>
            <Text style={styles.categoryCount}>{getEventCount(value.id)}</Text>
          </View>
        </View>
      ))}
    </WebCard>
  );
}
